import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'parseToSentenceCase',
})
export class ParseToSentenceCase implements PipeTransform {
  transform(text: string | undefined): string {
    if (!text) return '';
    const textConverted =
      text.substring(0, 1).toUpperCase() +
      text.substring(1, text.length).toLowerCase();

    return textConverted;
  }
}
